import React from 'react';
import teamPhoto from '../assets/teamPhoto.png'; // exemple

const About = () => {
  return (
    <section className="py-10 px-4 bg-white text-gray-800">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold mb-6">À propos de myPlum+</h1>
        
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="md:w-1/2">
            <p className="mb-4">
              myPlum+ est né d'une vision : rendre la procédure de séparation ou de divorce
              <strong> claire et abordable pour tous les Québécois</strong>.
            </p>
            <p className="mb-4">
              Je suis <strong>parajuriste en droit familial</strong>, spécialisé(e) dans le guide
              des couples qui souhaitent se séparer sans se ruiner. Mon frère et moi formons
              une petite équipe passionnée, disponible pour répondre à vos questions par email.
            </p>
            <p className="mb-4">
              Avec plus de 3 ans d'expérience directe et plus de 20 ans en collaboration avec
              des experts parajuridiques, nous avons aidé plus de <strong>150 familles</strong> à
              traverser leur séparation avec moins de stress et de coûts.
            </p>
          </div>
          <div className="md:w-1/2">
            <img
              src={teamPhoto}
              alt="Notre équipe"
              className="rounded-lg shadow-md"
            />
          </div>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">Nos valeurs</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Empathie :</strong> Nous savons à quel point une séparation peut être éprouvante.</li>
          <li><strong>Accessibilité :</strong> Nous parlons un langage clair, sans jargon juridique.</li>
          <li><strong>Transparence :</strong> Zéro frais cachés, zéro procédure inutile.</li>
        </ul>
        
        <div className="mt-8">
          <p>
            Ensemble, construisons un divorce ou une séparation plus sereine, plus humaine,
            et plus juste pour chacun.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
